import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, KeyValues3, LanguageKeyType, LocalService, PageKey, Status, TriggeredEvent, Wrapper3, Wrappers3 } from '../../../service/local.service';
import { LanguageContainerConfigComponent } from '../../popups/language-container-config/language-container-config.component';

@Component({
  selector: 'app-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss']
})
export class TipsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["table"]; maxBodyHeight = 0; wrapper: Wrappers3; pageKey: PageKey = PageKey.Tips;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(this.pageKey);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.configurationManagementService.getOnlyLanguagesConfig(this.pageKey, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.wrapper = result;
    });
  }

  onAction(index, key = '') {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(LanguageContainerConfigComponent);
        modalRef.componentInstance.parentId = key;
        modalRef.componentInstance.languageKeyType = LanguageKeyType.Tips;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            let wrapper = {
              content: { key: key, v1: this.pageKey.toString() } as KeyValues3,
              languageContents: result.data
            } as Wrapper3;
            this.onSave(wrapper);
          }
        });
      } break;
      case 2: {
        let item = this.wrapper.items.find(x => x.key == key);
        if (item) {
          this.configurationManagementService.activeInactiveStatus(key, ActiveInactiveFor.Tips).subscribe(result => {
            if (result == Status.Success) {
              item.isSelected = !item.isSelected;
            }
          });
        }
      } break;
      case 3: {
        let item = this.wrapper.items.find(x => x.key == key);
        if (item) {
          this.configurationManagementService.activeInactiveStatus(key, ActiveInactiveFor.TipsFlash).subscribe(result => {
            if (result == Status.Success) {
              item.v2 = item.v2 == '0' ? '1' : '0';
            }
          });
        }
      } break;
    }
  }

  onSave(wrapper: Wrapper3) {
    this.configurationManagementService.saveOnlyLanguagesConfig(wrapper).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }
}
